import { useContext, useEffect } from "react";
import { Box, Typography, Stack, Checkbox, Avatar, TextField, Select, MenuItem, FormControl } from "@mui/material"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { TxtEmail } from "../../../../../core/global/Format";
import { validateMobile, ValidateInt } from "../../../../../core/validator/Validator";
import { rqx } from "../../../../../core/request/API";
import { env } from "../../../../../core/Env";

export const OtherInformation = ({ handleChange }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { otherInfrmtn, types, mainInfrmtn } = realproperty_state;
    const detailStatus = [ { id: 1, name: "For Review" }, { id: 2, name: "For Occular" }, { id: 3, name: "For Details Completion"} ];
    const readChecklists = async () => {
        if (types.data.checkListItems.length === 0) {
            try {
                const res_checklists = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "check_list" });
                if (res_checklists) {
                    types.set((p) => ({...p, checkListItems: res_checklists}))
                }
            } catch (e) {
                console.error('Failed to fetch checklists items:', e);
            }
        }
    };

    useEffect(() => {
        readChecklists();
        // eslint-disable-next-line
    }, [])
    // checkboxes for checklists handler
    const handleChecklist = (id) => (e) => {
        otherInfrmtn.set((p) => {
            const updatedChecklist = e.target.checked
                ? [...(p.checkList || []), id] // add item if checked
                : (p.checkList || []).filter((item) => item !== id); // remove if unchecked

            return {
                ...p, checkList: updatedChecklist
            };
        });
    };
    // terms checkbox handler
    const handleIsAgreeToPayChange = (e) => {
        otherInfrmtn.set({
            ...otherInfrmtn.data,
            isAgreedToPay: { ...otherInfrmtn.data.isAgreedToPay, value: e.target.checked ? 1 : 0, stat: !e.target.checked },
        });
    };
    // handle change for contact details for buyers an property seller information
    const handleInputChange = (e, type) => {
        const { name, value } = e.target;
        const isValid = value !== "";
        otherInfrmtn.set({
            ...otherInfrmtn.data,
            [type]: {
                ...otherInfrmtn.data[type],
                [name]: {
                    ...otherInfrmtn.data[type][name],
                    value,
                    stat: name === "email" ? !TxtEmail(value) : name === "mobileNumber" ? !validateMobile(value) : !isValid,
                }
            }
        })
    }
    
    return (
        <Box>
            {types.data.checkListItems.length === 0 ? 
                <Box py="0.5rem" display="flex" alignItems="center" justifyContent="center">
                    <SnakeLoader bg="#11783C" size="7px" distance="7px" /> 
                </Box> 
            :
                <>
                    <Typography mb="0.5rem"> Contact Details for Buyer </Typography>
                    <Stack flexDirection="row" gap="1rem" mb="2rem">
                        <Box display="flex" alignItems="center">
                            <Avatar/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">First Name<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="firstName" value={otherInfrmtn.data.contact_details_for_buyers.firstName.value} onChange={(e) => handleInputChange(e,'contact_details_for_buyers')} error={otherInfrmtn.data.contact_details_for_buyers.firstName.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">Last Name<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="lastName" value={otherInfrmtn.data.contact_details_for_buyers.lastName.value} onChange={(e) => handleInputChange(e,'contact_details_for_buyers')} error={otherInfrmtn.data.contact_details_for_buyers.lastName.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">Email<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="email" value={otherInfrmtn.data.contact_details_for_buyers.email.value} onChange={(e) => handleInputChange(e,'contact_details_for_buyers')} error={otherInfrmtn.data.contact_details_for_buyers.email.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">Contact No.<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="mobileNumber" value={otherInfrmtn.data.contact_details_for_buyers.mobileNumber.value} onChange={(e) => handleInputChange(e,'contact_details_for_buyers')} onKeyPress={ValidateInt} inputProps={{ maxLength: 11 }} error={otherInfrmtn.data.contact_details_for_buyers.mobileNumber.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                    </Stack>
                    <Typography mb="0.5rem"> Property Seller Information </Typography>
                    <Stack flexDirection="row" gap="1rem" mb="2rem">
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">Contact Person:</Typography>
                            <TextField disabled name="contactPerson" value={mainInfrmtn.data.property_seller_information.contactPerson.value} onChange={(e) => handleInputChange(e,'property_seller_information')} error={mainInfrmtn.data.property_seller_information.contactPerson.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">Email:</Typography>
                            <TextField disabled name="email" value={mainInfrmtn.data.property_seller_information.email.value} onChange={(e) => handleInputChange(e,'property_seller_information')} error={mainInfrmtn.data.property_seller_information.email.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem">Mobile No.:</Typography>
                            <TextField disabled name="mobileNumber" value={mainInfrmtn.data.property_seller_information.mobileNumber.value} onChange={(e) => handleInputChange(e,'property_seller_information')} onKeyPress={ValidateInt} inputProps={{ maxLength: 11 }} error={mainInfrmtn.data.property_seller_information.mobileNumber.stat} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#ffffff" }} InputLabelProps={{ shrink: false }}/>
                        </Box>
                    </Stack>
                    <Typography mb="1rem"> Property Checklist </Typography>
                    {types.data.checkListItems?.map((v, i) => (
                        <Stack key={i} direction="row" alignItems="center">
                            <Checkbox size="small" onChange={handleChecklist(v.id)} checked={otherInfrmtn.data.checkList?.includes(v.id)}/>
                            <Typography>{v.name}</Typography>
                        </Stack>
                    ))}
                    <Stack direction="row" sx={{ mt: "1.5rem", px: "0.5rem" }} spacing={1} alignItems="center">
                        <Checkbox size="small" checked={otherInfrmtn.data.isAgreedToPay.value !== 0} onChange={handleIsAgreeToPayChange}/>
                        <Typography>I agree to pay commission on the sale of my property once it is sold through your services.</Typography>
                    </Stack>
                    {otherInfrmtn.data.isAgreedToPay.stat && (
                        <Typography color="error" sx={{ pl: "3.2rem", fontSize: "0.875rem", fontStyle: "italic" }}>
                            You must agree to the terms!
                        </Typography>
                    )}
                    <Typography mb="0.5rem" mt="2rem" > Property Detail Status </Typography>
                    <FormControl size="small" sx={{ bgcolor: "#ffffff", width: "15rem" }} >
                        <Select name="detailStatus" id="detail-status" value={otherInfrmtn.data?.detailStatus} onChange={(e) => handleChange(e, otherInfrmtn)}>
                            {detailStatus.length > 0 ? (
                                detailStatus?.map((v, i) => (
                                    <MenuItem key={i} value={v.id} >
                                        {v.name}
                                    </MenuItem>
                                ))
                            ) : (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Typography sx={{ fontSize: "0.8rem", fontStyle: "italic", fontWeight: "600", mr: "1rem", color: "#635f5a" }}>Getting Detail Status</Typography>
                                    <SnakeLoader bg="#11783C" size="5px" distance="4px" />
                                </Box>
                            )}
                        </Select>
                    </FormControl>
                </>
            }
        </Box>
    )
}
